import React from 'react'
import { Segment } from '../common/Layout'
import { Action } from '@foodsby/nutrient'

export const PaymentOptionsPanel = ({
  paymentOptions,
  onDeletePaymentOption,
}) => (
  <Segment>
    <div className="HeaderSection">
      <h5 className="HeaderSection-heading">Payment Options</h5>
    </div>
    {paymentOptions && paymentOptions.length > 0 ? (
      <div className="row">
        <table>
          <thead>
            <tr>
              <th className="ProCard-label">Card Ending In</th>
              <th className="ProCard-label">Zip</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {paymentOptions.map(paymentOption => (
              <PaymentOptionsTableRow
                key={paymentOption.ccProfileId}
                onDeletePaymentOption={onDeletePaymentOption}
                paymentOption={paymentOption}
              />
            ))}
          </tbody>
        </table>
      </div>
    ) : (
      <NoSavedPaymentOptions />
    )}
  </Segment>
)

export const PaymentOptionsTableRow = ({
  paymentOption: {
    ccProfileId,
    lastFour,
    cardAddress: { zipcode },
  },
  onDeletePaymentOption,
}) => (
  <tr>
    <td>
      <span className="cc-hidden-dots">**** **** **** </span>
      {lastFour}
    </td>
    <td>{zipcode}</td>
    <td>
      <Action
        className="icon delete-payment-option"
        onClick={evt => {
          evt.preventDefault()
          onDeletePaymentOption(ccProfileId)
        }}
      >
        <i className="icon-trash" />
      </Action>
    </td>
  </tr>
)

export const NoSavedPaymentOptions = () => (
  <div className="noSavedOptions">
    You currently do not have any saved credit cards.
  </div>
)

export default PaymentOptionsPanel
